<template>
  <mds-table>
    <mds-thead>
      <mds-th
        v-for="(header, index) in columns"
        :key="index"
        :right-aligned="header.align === 'right'"
        :style="header.style"
      >
        {{ header.text }}
      </mds-th>
    </mds-thead>
    <mds-tbody>
      <mds-tr v-for="(row, rowIndex) in rows" :key="rowIndex">
        <mds-td
          v-for="(header, colIndex) in columns"
          :key="colIndex"
          :right-aligned="header.align === 'right'"
        >
          <slot :name="header.fieldName" :row="row" :column="header">
            {{ row[header.fieldName] }}
          </slot>
        </mds-td>
      </mds-tr>
    </mds-tbody>
  </mds-table>
</template>

<script>
import { MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd } from '@mds/data-table';

export default {
  name: 'data-table',
  components: {
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
